module.exports = __webpack_public_path__ + "Times_Education_Excellence_2022-2718b806.webp";